<div class="flex w-full bg-white rounded-xl">
  <!-- sidebar: stays on screen while a long page scrolls (top-8 and 4rem match main's lg:p-8),
       and scrolls on its own when the window is too short for it -->
  <div class="flex-col pl-2 pt-8 pr-2 hidden lg:flex sticky top-8 self-start h-[calc(100vh-4rem)] overflow-y-auto">
    <app-sidebar></app-sidebar>
  </div>
  <div class="flex flex-col flex-1 min-w-0 lg:border-l">
    <!-- archived-project alerts, above every page (task 4.10) -->
    <app-sync-alert-banner></app-sync-alert-banner>
    <!-- router -->
    <div class="h-full p-8 pl-4">
      <router-outlet></router-outlet>
    </div>
    @if (showFeedbackButton) {
      <div class="fixed right-10 bottom-10 group">
        <a pButton pRipple [rounded]="true" #feedbackButton severity="danger" [text]="true" [raised]="true" size="large" class="flex w-6 h-6 p-6 group-hover:w-28 overflow-hidden transition-all duration-300 bg-white">
          <span pButtonIcon class="translate-x-[2.2rem] group-hover:translate-x-0 duration-300 transition-transform block pi pi-megaphone primengt text-xl"></span>
          <span pButtonLabel class="block opacity-0 group-hover:opacity-100 text-base transition-opacity duration-300">Support</span>
        </a>
      </div>
    }
  </div>
